<template>
    <div>
        <p class="title">选择受理公安机关</p>
        <van-cell-group>
            <van-cell title="选择公安机关" required/>
            <!--第一级部门-->
            <van-field v-model="firstDeptName" placeholder="请选择" is-link readonly input-align="right" @click="firstSelect"/>
            <van-popup v-model="firstSelectShow" position="bottom">
                <van-picker :columns="firstDeptNameList" show-toolbar @cancel="onCancelFirst" @confirm="onConfirmFirst"/>
            </van-popup>
            <!--第二级部门-->
            <van-field v-model="secondDeptName" placeholder="请选择" is-link readonly input-align="right" @click="secondSelect" v-if="secondShow"/>
            <van-popup v-model="secondSelectShow" position="bottom">
                <van-picker :columns="secondDeptNameList" show-toolbar @cancel="onCancelSecond" @confirm="onConfirmSecond"/>
            </van-popup>
            <!--第三级部门-->
            <van-field v-model="thirdDeptName" placeholder="请选择" is-link readonly input-align="right" @click="thirdSelect" v-if="thirdShow"/>
            <van-popup v-model="thirdSelectShow" position="bottom">
                <van-picker :columns="thirdDeptNameList" show-toolbar @cancel="onCancelThird" @confirm="onConfirmThird"/>
            </van-popup>
        </van-cell-group>
    </div>
</template>

<script>
  /**
   * Description: 申请信息
   * Author: wangyan
   * Date: 2019-04-29
   * Time: 13:20
   */

  import { CellGroup, Cell, Field, Popup, Picker } from 'vant'
  import { matterApiMap } from '@/api/matter'

  export default {
    name: "SelectPolice",
    components: {
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Field.name]: Field,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
    },
    props: {
      matterInfo: {
        type: Object,
        default: () => ({})
      },
      declareInfo: {
        type: Object,
        default: () => ({})
      },
      informationShowData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        firstDeptNameList: [], // 存放第一级部门名字
        firstDeptList: [], // 存放第一级部门信息
        firstDeptName: '', // 选中的第一级部门名字
        firstDeptIndex: null, // 选中的第一级部门下标
        firstSelectShow: false, // 第一级部门选择器的显示与隐藏

        secondShow: false, // 控制第二级部门选择框的显示与隐藏
        secondDeptNameList: [], // 存放第二级部门名字
        secondDeptList: [], // 存放第二级部门信息
        secondDeptName: '', // 选中的第二级部门名字
        secondDeptIndex: null, // 选中的第二级部门下标
        secondSelectShow: false, // 第二级部门选择器的显示与隐藏

        thirdShow: false, // 控制第三级部门选择框的显示与隐藏
        thirdDeptNameList: [], // 存放第三级部门名字
        thirdDeptList: [], // 存放第三级部门信息
        thirdDeptName: '', // 选中的第三级部门名字
        thirdDeptIndex: null, // 选中的第三级部门下标
        thirdSelectShow: false, // 第三级部门选择器的显示与隐藏


      }
    },
    watch: {
      matterInfo: {
        handler(val) {
          if (val.matNum) {
            this.getfirstDept()
          }
        },
        deep: true
      }
    },
    methods: {
      /**
       * 获取第一级部门信息
       */
      async getfirstDept() {
        try {
          const data = {
            matNum: this.matterInfo.matNum,
            deptId: global.firstDeptGuid,
            lev: global.firstLevel
          }
          const res = await this.$httpUtils.getCommonUtils(matterApiMap.getSelDept, data)
            //判断是否有配置部门信息
            if(res.data !== ''){
                this.firstDeptList = res.data.data
                for (let index in this.firstDeptList) {
                    // 1：选项显示'可选'， 0：不显示(存在下一级)
                    if (this.firstDeptList[index].canApply === '1') {
                        this.firstDeptNameList.push(`${this.firstDeptList[index].deptName} (可选)`)
                    } else {
                        this.firstDeptNameList.push(this.firstDeptList[index].deptName)
                    }
                }
            }

        } catch (error) {
          console.log(error)
        }

      },

      /**
       * 初始化涉及到二级部门的信息
       */
      initializationSecondInfo() {
        this.secondShow = false
        this.secondDeptNameList = []
        this.secondDeptList = []
        this.secondDeptName = ''
        this.secondDeptIndex = null
      },

      /**
       * 初始化涉及到三级部门的信息
       */
      initializationThirdInfo() {
        this.thirdShow = false
        this.thirdDeptNameList = []
        this.thirdDeptList = []
        this.thirdDeptName = ''
        this.thirdDeptIndex = null
      },

      /**
       * 打开第一级部门选择器
       */
      firstSelect() {
        this.firstSelectShow = true
      },

      /**
       * 关闭第一级部门选择器
       */
      onCancelFirst() {
        this.firstSelectShow = false
      },

      /**
       * 选择第一部门选择器
       * @param value 选择后返回的第一部门名字
       * @param index 选择后返回的第一部门数组下标
       */
      async onConfirmFirst(value, index) {
        this.firstDeptName = this.firstDeptList[index].deptName
        this.firstDeptIndex = index
        this.firstSelectShow = false

        this.initializationSecondInfo()
        this.initializationThirdInfo()
        if (!this.firstDeptList[index].canApply || this.firstDeptList[index].canApply === '1') {
          return
        }
        this.secondShow = true
        try {
          const data = {
            matNum: this.matterInfo.matNum,
            deptId: this.firstDeptList[index].deptId,
            lev: global.secondLevel
          }
          const res = await this.$httpUtils.getCommonUtils(matterApiMap.getSelDept, data)
          this.secondDeptList = res.data.data
          for (let index in this.secondDeptList) {
            if (this.secondDeptList[index].canApply === '1') {
              this.secondDeptNameList.push(`${this.secondDeptList[index].deptName} (可选)`)
            } else {
              this.secondDeptNameList.push(this.secondDeptList[index].deptName)
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      /**
       * 打开第二级部门选择器
       */
      secondSelect() {
        this.secondSelectShow = true
      },

      /**
       * 关闭第二级部门选择器
       */
      onCancelSecond() {
        this.secondSelectShow = false
      },

      /**
       * 选择第二部门选择器
       * @param value 选择后返回的第一部门名字
       * @param index 选择后返回的第一部门数组下标
       */
      async onConfirmSecond(value, index) {
        this.secondDeptName = this.secondDeptList[index].deptName
        this.secondDeptIndex = index
        this.secondSelectShow = false

        this.initializationThirdInfo()
        if (!this.secondDeptList[index].canApply || this.secondDeptList[index].canApply === '1') {
          return
        }
        this.thirdShow = true
        try {
          const data = {
            matNum: this.matterInfo.matNum,
            deptId: this.secondDeptList[index].deptId,
            lev: global.thirdLevel
          }
          const res = await this.$httpUtils.getCommonUtils(matterApiMap.getSelDept, data)
          this.thirdDeptList = res.data.data
          for (let index in this.thirdDeptList) {
            if (this.thirdDeptList[index].canApply === '1') {
              this.thirdDeptNameList.push(`${this.thirdDeptList[index].deptName} (可选)`)
            } else {
              this.thirdDeptNameList.push(this.thirdDeptList[index].deptName)
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      /**
       * 打开第三级部门选择器
       */
      thirdSelect() {
        this.thirdSelectShow = true
      },

      /**
       * 关闭第三级部门选择器
       */
      onCancelThird() {
        this.thirdSelectShow = false
      },

      /**
       * 选择第三部门选择器
       * @param value 选择后返回的第三部门名字
       * @param index 选择后返回的第三部门数组下标
       */
      onConfirmThird(value, index) {
        this.thirdDeptName = this.thirdDeptList[index].deptName
        this.thirdDeptIndex = index
        this.thirdSelectShow = false
      },

      /**
       * 赋值给父组件declareInfo.deptId，此方法由父组建调用
       */
      setDeptId() {
        this.informationShowData.allDeptName = this.firstDeptName + this.thirdDeptName
        if (this.thirdShow) {
          if (this.thirdDeptList.length > 0 && (this.thirdDeptIndex === 0 || this.thirdDeptIndex)) {
            this.declareInfo.deptId = this.thirdDeptList[this.thirdDeptIndex].deptId
            this.informationShowData.deptName = this.thirdDeptList[this.thirdDeptIndex].deptName
          } else {
            this.declareInfo.deptId = ''
            this.informationShowData.deptName = ''
          }
        } else if (this.secondShow) {
          if (this.secondDeptList.length > 0 && (this.secondDeptIndex === 0 || this.secondDeptIndex)) {
            this.declareInfo.deptId = this.secondDeptList[this.secondDeptIndex].deptId
            this.informationShowData.deptName = this.secondDeptList[this.secondDeptIndex].deptName
          } else {
            this.declareInfo.deptId = ''
            this.informationShowData.deptName = ''
          }
        } else if (this.firstDeptList.length > 0 && (this.firstDeptIndex === 0 || this.firstDeptIndex)) {
          this.declareInfo.deptId = this.firstDeptList[this.firstDeptIndex].deptId
          this.informationShowData.deptName = this.firstDeptList[this.firstDeptIndex].deptName

        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
